export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"6\" stroke=\"#7B61FF\" stroke-width=\"4\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};